module.exports = __webpack_public_path__ + "fonts/b6a23b29160981430c7b7a19e8a3173b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/driver.svg
// module id = 2051
// module chunks = 0